import config from './config'
import theme from './theme'

export { config }
export { theme }

export default{ config, theme }


// WEBPACK FOOTER //
// ./src/app/configuration/Template/index.js